import {useDroppable} from '@dnd-kit/core';
import {rectSortingStrategy, SortableContext} from '@dnd-kit/sortable';
import SortableItem from './sortable-item';
import React from 'react';

import {connect} from 'redux/index.js';
import {CollapsibleHeader} from '@henrybuilt/react-lib';
import _ from 'lodash';
import K from 'k';

const DroppableSection = ({
  id: sectionId, items, draggingId, notesAreVisible, onRemove, onUpdateNotes, media, isPrinting,
  itemSize = {width: '1.5in', height: '1.5in'},
}) => {
  const {isOver, setNodeRef} = useDroppable({id: sectionId});
  const containsDraggingId = _.indexOf(items, item => item.id === draggingId) !== -1;

  const styles = {
    droppable: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      backgroundColor: isOver ? K.colors.gray : K.colors.base,
      marginBottom: K.spacing * 2,
      breakAfter: 'page',
    },
    droppableArea: {
      width: '100%',
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: K.spacing * 5,
      paddingTop: K.spacing,
      minHeight: K.spacing * 3,
      borderRadius: K.borderRadius,
      backgroundColor: isOver && !containsDraggingId ? K.colors.gray : K.colors.base,
    },
    header: {
      marginBottom: K.spacing * 2, //TODO troubleshoot bottom spacing
    },
  };

  const handleUpdateNotes = ({itemId, value}) => {
    onUpdateNotes({itemId, value});
  };

  const handleRemove = (id) => () => {
    onRemove({id});
  };

  const sortableContext = (
    <SortableContext {...{id: sectionId, items}} strategy={rectSortingStrategy}>
      <div style={styles.droppableArea}>
        {items.map(({id, notes}) => {
          const url = _.find(media, {id})?.url;

          return (
            <SortableItem
              {...{id, notes, notesAreVisible, isPrinting, url}}
              key={`sortable-item-${id}`}
              onRemoveMedium={handleRemove(id)}
              onUpdateNotes={handleUpdateNotes}
              isActiveItem={draggingId === id}
              size={itemSize}
            />
          );
        })}
      </div>
    </SortableContext>
  );

  return (
    <div ref={setNodeRef} style={styles.droppable}>
      <CollapsibleHeader
        ref={setNodeRef}
        key={`header-${sectionId}`}
        header={_.startCase(sectionId)}
        defaultCollapsed={false}
        type={'h2'}
        contentStyle={styles.content}
        headerStyle={styles.header}
        expandIcon={isPrinting ? (<></>) : undefined}
      >{sortableContext}</CollapsibleHeader>
    </div>
  );
};

export default connect({
  mapState: state => {
    return {
      media: state.resources.media.byId,
    };
  }
})(DroppableSection);
